import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { SEO } from "@/lib/seo";
import { PublicFooter } from "./FAQ";
import JobManagementContent from "@/components/marketing/JobManagementContent";
import metadata from "@/data/jobManagementSeo.json";
import schemas from "@/data/jobManagementSchema.json";
import "@/components/marketing/jobManagement.css";

export default function JobManagementNZ() {
  return <div className="web-seo bg-[#f6f5f1] text-[#142635] min-h-screen">
    <SEO {...metadata} jsonLd={schemas} />
    <a className="web-skip" href="#main-content">Skip to content</a>
    <MarketingHeader />
    <JobManagementContent />
    <PublicFooter />
  </div>;
}
